import * as React from "react";

function SvgVideo(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16" {...props}><path d="M18 0H2a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V2a2 2 0 00-2-2zM8 12.5v-9L14 8l-6 4.5z" fill={props.color1} /></svg>;
}

export default SvgVideo;